import type { IconName } from '@frontend/icons';
import type { NavItem } from '@frontend/nav-primitives';

type CreateNavItemParams = Omit<NavItem, 'iconName'> & {
  iconName: IconName;
};

export const createNavItem = (_id: string, params: CreateNavItemParams): NavItem => {
  return { ...params } as const;
};

export const createSubNavItems = (subNavItems: NavItem['subNavItems']): NavItem['subNavItems'] =>
  subNavItems.filter((item) => item.show !== false);
